import { apiInstance } from '@diamond/shared/utils';

export async function updateHighlightPromo(
  access_token: string,
  promo_group_id: string,

  // TODO: Temporary type, remove this after backend is updated
  payload: {
    product_highlight_number?: number | undefined;
    customer_type?: string | undefined;
  }
) {
  return apiInstance(access_token).patch(
    `/backoffice/promo/${promo_group_id}/product-highlight-number`,
    payload
  );
}
